/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
let pageNumber = 1;
let maxPages = 1;
async function loadmore(button, txt) {
    const container = document.querySelector('.ajax-posts');

    if (!container) {
        return;
    }
    pageNumber++;
    const formData = new FormData();
    formData.append('action', 'load_more_posts');
    formData.append('ppp', ajax_posts.ppp);
    formData.append('offset', ajax_posts.offset);
    formData.append('pageNumber', pageNumber);
    if (ajax_posts.stacked) {
        formData.append('stacked', ajax_posts.stacked);
    }
    if (ajax_posts.listing) {
        formData.append('listing', ajax_posts.listing);
    }

    try {
        const response = await fetch(ajax_posts.ajaxurl, {
            method: 'POST',
            body: formData,
        });
        const html = await response.text();
        if (html) {
            container.innerHTML += html;
            button.disabled = false;
            button.innerText = txt;
        } else {
            button.remove();
        }
        if (maxPages === pageNumber) {
            button.remove();
        }
    } catch (error) {
        console.log(error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('.load-more');
    if (button) {
        maxPages = button.dataset && button.dataset.max ? parseInt(button.dataset.max, 10) : 1;
        button.addEventListener('click', () => {
            button.disabled = true;
            const txt = button.textContent || button.innerText;
            loadmore(button, txt);
            button.innerText = 'Loading...';
        });
    }
});
